import Admin from "./admin/reducer";

const reducers = { Admin };

export default reducers;
